module.exports = __webpack_public_path__ + "static/media/2.10638fd1.png";